<template>
    <div>
        <!-- Working time -->
        <div class="color-theme size-default hts-form-input mb-6">
            <label for="workingTime">
                {{ $t('labels.nodeModule.workingTime') }}
                <span
                    v-if="!disabled"
                    class="text-error-500 ml-1">
                    *
                </span>
            </label>

            <span
                class="h-12 w-80 mt-3 cursor-pointer border-1 rounded-xl flex items-center justify-center text-base font-bold text-white"
                :class="[!checkEnterWorkingTime('inTime') ? 'bg-orange-300' : 'bg-success-500']"
                @click="openModal('inTime')">
                {{ $t('labels.settingTimeWorkingInTime') }} <span
                    v-if="!disabled"
                    class="ml-2 text-error-500">
                    *
                </span>
            </span>

            <span
                :class="[!checkEnterWorkingTime('overTime') ? 'bg-orange-300' : 'bg-success-500']"
                class="mt-3 h-12 w-80 cursor-pointer border-1 rounded-xl flex items-center justify-center text-base font-bold text-white"
                @click="openModal('overTime')">
                {{ $t('labels.settingTimeWorkingOverTime') }} <span
                    v-if="!disabled"
                    class="ml-2 text-error-500 opacity-0">
                    *
                </span>
            </span>

            <!--        <div -->
            <!--          class="h-12 w-32 mt-3 cursor-pointer border-1 rounded-full flex items-center justify-center" -->
            <!--          :class="[!checkEnterWorkingTime('weekend') ? 'bg-orange-500' : 'bg-success-500']" -->
            <!--          @click="openModal('weekend')" -->
            <!--        > -->
            <!--          <span -->
            <!--            class="text-base font-bold text-white" -->
            <!--          > -->
            <!--            {{ $t('labels.nodeModule.weekend') }} -->
            <!--          </span> -->
            <!--        </div> -->

            <edit-working-time
                ref="workingTimeModal"
                type="inTime"
                :disabled="disabled"
                @update="updateWorkingTime" />
        </div>
    </div>
</template>
<script setup lang="ts">
import EditWorkingTime from './edit-working-time.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const { modelValue } = toRefs(props)
const workingTimeModal = ref()

const emits = defineEmits(['update:modelValue', 'close', 'change'])

const cValue = computed({
  get () {
    return modelValue?.value
  },
  set (val) {
    emits('update:modelValue', val)
  }
})

const openModal = (type: string) => {
  if (workingTimeModal.value) {
    workingTimeModal.value.open(cValue.value, type)
  }
}

const checkEnterWorkingTime = (type: string) => {
  try {
    for (const day in cValue.value) {
      const dayTimeSlots = cValue.value[day]
      for (const timeSlot of dayTimeSlots) {
        if (timeSlot.type === type) {
          return true
        }
      }
    }
    return false
  } catch (e) {
    return false
  }
}

const updateWorkingTime = (times: { [key: string]: any }) => {
  cValue.value = times
}
</script>
